import React from "react";
import ConfirmModal from "components/ConfirmModal";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { rulesSetStore } from "../RulesSetStore";
import { useLocation, useNavigate } from "react-router";
import { dynamicMEStore } from "store/Mapping/DMEStore";
import { buildingStore } from "store/Building/BuildingStore";

const NoRulesPopup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const openRulesEditor = () => {
    dynamicMEStore.setSelectedRows([]);
    dynamicMEStore.setSelectAllChecked(false);
    navigate(
      `/${buildingStore.currentBuilding?.organisation_id}/rules-editor`,
      {
        replace: true,
        state: location.pathname,
      }
    );
  };

  return (
    <ConfirmModal
      close={() => rulesSetStore.setOpenNoRulePopup(false)}
      open={rulesSetStore.openNoRulePopup}
      confirmButtonTitle={t("rulesEditor.createRule")}
      descriptionMesage={t("rulesEditor.noRulesDescription")}
      title={t("rulesEditor.noRulesTitle")}
      type="info"
      onConfirm={openRulesEditor}
      containerClassName="!min-w-[640px]"
    />
  );
};

export default observer(NoRulesPopup);
